module.exports = new __parcel__URL__("CineBrick.d1d5a746.webp").toString();